import { Button, Typography } from 'antd';
import { FC, memo, useEffect, useState } from 'react';
import { EyeSlash } from 'react-bootstrap-icons';

import { CopyableText } from '@/common/components/CopyableText/CopyableText';

import './HiddenPassword.scss';

interface Props {
  password: string;
  label?: true | string;
}

export const HiddenPassword: FC<Props> = memo(({ password, label }) => {
  const [isPasswordHidden, setIsPasswordHidden] = useState(true);

  const handleShowPassword = (): void => {
    setIsPasswordHidden(false);
  };

  const handleHidePassword = (): void => {
    setIsPasswordHidden(true);
  };

  useEffect(() => {
    return () => {
      setIsPasswordHidden(true);
    };
  }, []);

  return (
    <div className="hidden-password">
      {!!label && <Typography.Text type="secondary">{typeof label === 'string' ? label : 'Пароль'}:&nbsp;</Typography.Text>}

      {isPasswordHidden ? (
        <Button onClick={handleShowPassword} size="small" type="dashed">
          показати
        </Button>
      ) : (
        <>
          <Button onClick={handleHidePassword} size="small" type="dashed" icon={<EyeSlash size={12} />} />
          &nbsp;
          <CopyableText className="hidden-password__copyable-text" textToCopy={password}>
            {password}
          </CopyableText>
        </>
      )}
    </div>
  );
});
